var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add_btn font14 font_weight500 colof ",on:{"click":_vm.addAddress}},[_c('img',{attrs:{"src":require("@/assets/common/icon_add@2x.png"),"alt":""}}),_c('span',{staticClass:"font_add"},[_vm._v("新增收货地址")])])}
var staticRenderFns = []

export { render, staticRenderFns }